// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2_BLt","overflowing":"ReadFullNote_overflowing__1LhBD"};